import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function uid(prefix = "id") {
  return `${prefix}_${Math.random().toString(36).slice(2, 9)}${Date.now().toString(36).slice(-4)}`;
}

export function initials(name: string) {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");
}

export function formatRelative(ts: number | null | undefined) {
  if (!ts) return "";
  const diff = Date.now() - ts;
  const abs = Math.abs(diff);
  const min = 60 * 1000;
  const hour = 60 * min;
  const day = 24 * hour;
  const week = 7 * day;
  const past = diff >= 0;
  const fmt = (n: number, unit: string) => `${n}${unit}${past ? "" : ""}`;
  if (abs < min) return past ? "just now" : "now";
  if (abs < hour) return fmt(Math.floor(abs / min), "m");
  if (abs < day) return fmt(Math.floor(abs / hour), "h");
  if (abs < week) return fmt(Math.floor(abs / day), "d");
  if (abs < 4 * week) return fmt(Math.floor(abs / week), "w");
  const d = new Date(ts);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function formatDate(ts: number | null | undefined) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function hashColor(key: string, palette: string[]) {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) | 0;
  return palette[Math.abs(h) % palette.length];
}
